import { SCOPES } from '../api';
import type { NavNode } from '@nyce/admin-kit/console';

const r = SCOPES.automationRead;

/** The Automation group's pages, in screen order (children of its node in `NAV`). */
export const AUTOMATION_NAV: NavNode[] = [
  {
    path: '/automation/agents',
    label: 'Agents',
    requires: r,
    description: 'Warehouse agents: connection, version, system info; restart, update, secrets.',
  },
  {
    path: '/automation/routes',
    label: 'Routes',
    requires: r,
    description: 'Forward and reverse TCP tunnels per agent, with live traffic.',
  },
  {
    path: '/automation/file-watchers',
    label: 'File watchers',
    requires: r,
    description: 'SMB shares the agents watch and where the files are posted.',
  },
  {
    path: '/automation/logs',
    label: 'Agent logs',
    requires: r,
    description: 'An agent’s live log, debug logging and its log files.',
  },
  {
    path: '/automation/traffic',
    label: 'Traffic',
    requires: r,
    description: 'Bytes and channels per route over the last week.',
  },
  {
    path: '/automation/tenants',
    label: 'Tenants',
    requires: r,
    description: 'The gateway’s tenants the agents belong to.',
  },
];
